import React from 'react';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { sidebarShortcutLabel } from '@/lib/sidebarState';
import RailTooltip from './RailTooltip';

interface SidebarCollapseToggleProps {
  collapsed: boolean;
  onToggle: () => void;
  /** Id of the rail it folds. */
  controls?: string;
}

/**
 * Quiet icon button at the foot of the desktop rail. It sits in the icon
 * column (same place in both states) and names itself plus ⌘B / Strg+B.
 */
export default function SidebarCollapseToggle({ collapsed, onToggle, controls }: SidebarCollapseToggleProps) {
  const label = collapsed ? 'Seitenleiste ausklappen' : 'Seitenleiste einklappen';
  const Icon = collapsed ? PanelLeftOpen : PanelLeftClose;

  return (
    <RailTooltip
      enabled
      label={
        <span className="flex items-center gap-2">
          {label}
          <kbd className="rounded border border-border bg-muted px-1.5 font-sans text-[11px] leading-5 text-muted-foreground">
            {sidebarShortcutLabel()}
          </kbd>
        </span>
      }
    >
      <Button
        type="button"
        variant="ghost"
        aria-label={label}
        aria-expanded={!collapsed}
        aria-controls={controls}
        aria-keyshortcuts="Meta+B Control+B"
        onClick={onToggle}
        className="h-10 w-12 px-0 text-muted-foreground hover:text-foreground"
      >
        <Icon className="h-5 w-5" />
      </Button>
    </RailTooltip>
  );
}
